/* eslint-disable */
import * as _ExtensionEditor2 from '@bingads-webui-campaign-legacy/adextension-sitelink/view/extension-editor-2';
var ExtensionEditor2 = _ExtensionEditor2.default;
export default ExtensionEditor2;

